import type { WalkEvent, WalkSnapshot, WalkState } from './types.js';

// Pure reducer. Returns same reference on no-op transitions so dispatch
// can short-circuit equality.
export function walkTransition(state: WalkState, event: WalkEvent): WalkState {
  switch (event.type) {
    case 'TOGGLE_ACTIVE':
      return { ...state, active: !state.active };
    case 'EXIT':
      if (!state.active) return state;
      return { ...state, active: false };
  }
}

export function walkSnapshot(state: WalkState): WalkSnapshot {
  return {
    active: state.active,
    eyeHeight: state.eyeHeight,
    floorHeight: state.floorHeight,
  };
}
